module.exports = __webpack_public_path__ + "assets/img/4_916_big.a6036078.jpg";